import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../services/AuthService';
import { UserType } from '../types';
import './Login.css';

const DriverLogin: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const user = await AuthService.login(formData.email, formData.password);
      
      if (user.userType === UserType.DRIVER) {
        navigate('/driver-dashboard');
      } else {
        setError('Bu hesap şoför hesabı değil. Lütfen yolcu girişini kullanın.');
      }
    } catch (error: any) {
      setError(error.message || 'Giriş başarısız oldu.');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setResetMessage('');

    try {
      await AuthService.resetPassword(resetEmail);
      setResetMessage('Şifre sıfırlama e-postası gönderildi. E-posta kutunuzu kontrol edin.');
      setShowForgotPassword(false);
      setResetEmail('');
    } catch (error: any) {
      setError(error.message || 'Şifre sıfırlama başarısız oldu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <button 
            className="back-btn"
            onClick={() => navigate('/')}
          >
            ← Ana Sayfa
          </button>
          <h2>Şoför Girişi</h2>
          <p>Taxicim şoför paneline hoş geldiniz</p>
        </div>

        {!showForgotPassword ? (
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">E-posta</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                placeholder="ornek@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Şifre</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
                placeholder="Şifrenizi girin"
              />
            </div>

            {error && <div className="error-message">{error}</div>}
            {resetMessage && <div className="success-message">{resetMessage}</div>}

            <button 
              type="submit" 
              className="login-btn driver-login-btn"
              disabled={loading}
            >
              {loading ? 'Giriş yapılıyor...' : 'Şoför Girişi'}
            </button>

            <div className="forgot-password-link">
              <a onClick={() => setShowForgotPassword(true)}>
                Şifremi Unuttum
              </a>
            </div>
          </form>
        ) : (
          <form onSubmit={handleForgotPassword} className="login-form">
            <div className="form-group">
              <label htmlFor="resetEmail">E-posta Adresiniz</label>
              <input
                type="email"
                id="resetEmail"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                required
                placeholder="ornek@email.com"
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button 
              type="submit" 
              className="login-btn driver-login-btn"
              disabled={loading}
            >
              {loading ? 'Gönderiliyor...' : 'Şifre Sıfırlama E-postası Gönder'}
            </button>

            <div className="forgot-password-link">
              <a onClick={() => setShowForgotPassword(false)}>
                ← Giriş Sayfasına Dön
              </a>
            </div>
          </form>
        )}

        <div className="login-footer">
          <p>Hesabınız yok mu? <a onClick={() => navigate('/driver-registration')}>Kayıt Ol</a></p>
          <p>Yolcu musunuz? <a onClick={() => navigate('/passenger-login')}>Yolcu Girişi</a></p>
        </div>
      </div>
    </div>
  );
};

export default DriverLogin; 